$(function () {
  $(document).on("change", ".custom-file-input", function (e) {
    var $tar = $(e.target);
    var $wrapper = $(this).parent();
    var fieldID = $wrapper.parent().attr("data-field-id");
    // Displays the filename by removing extraneouse browser path information.
    var filename = $tar.val().replace(/C:\\fakepath\\/g, "");
    var order = $wrapper.parent().children(".file-wrapper").length;
    var clone;

    // Ensure the filename variable does not have an empty string. Without this
    // check, an invalid entry is created on "Cancel" of file selection.
    if (filename.length) {
      // Only clone if creating a new file. Otherwise, just replace the name.
      if ($wrapper.hasClass("selected") == false) {
        // Create a deep clone of the wrapper with the 'true' arguments.
        clone = $wrapper.clone(true, true);

        // Clear the value of the clone's input field.
        $(clone).find(".custom-file-input").val("");
        // Remove required attribute from clone.
        $(clone).find(".custom-file-input").prop("required", false);

        // Update the clone and it's children's attributes with the new order distinction.
        $(clone).attr("data-file-order", order);
        $(clone).attr("id", "file-" + order);
        $(clone)
          .find(".custom-file-upload")
          .attr("for", "field_" + fieldID + "_file_" + order);
        $(clone)
          .find(".custom-file-input")
          .attr("id", "field_" + fieldID + "_file_" + order);

        // Append the clone to '.file-input', append the trash icon element,
        // update the label text, and add the 'selected' class to the original '.file-wrapper',
        $wrapper.parent().append(clone);
        $wrapper.append('<i class="fa-solid fa-trash remove-file-field"></i>');
        $wrapper.find(".custom-file-upload").text("Replace File");
        $wrapper.addClass("selected");
      }

      // Include the filename next to the label.
      $tar.siblings(".file-name").html(filename);

      if ($tar.closest("div.input-group").has("ul.errors").length > 0) {
        $tar.closest("div.input-group").find("ul.errors").remove();
      }
    }
  });

  // Remove the 'file-wrapper' and contents of a selected file when the trash
  // icon is clicked.
  $(document).on("click", "i.remove-file-field", function (e) {
    var $tar = $(e.target);
    var $wrapper = $tar.closest(".file-wrapper");
    var $fileInputsParent = $wrapper.closest(".file-input");
    var fieldID = $fileInputsParent.attr("data-field-id");
    var deletingIndex = $wrapper.data("fileOrder");
    var requiredBool = $('.file-input[data-field-id="' + fieldID + '"]')
      .find("#field_" + fieldID + "_file_0")
      .prop("required");
    var $wrappers;

    // Remove the parent element for which the trash icon belongs.
    $wrapper.remove();
    $wrappers = $fileInputsParent.children(".file-wrapper");

    // Create an array from the remaining '.file-wrapper's, and iterate over them
    // to determine if attributes need to be updated.
    [].forEach.call($wrappers, function (wrapper, i, arr) {
      var orderToUpdate = $(wrapper).attr("data-file-order");
      var newOrder;

      // Define and update newOrder as 1 less its current if wrapper was dispayed
      // further down the list than the removed element.
      if (orderToUpdate > deletingIndex) {
        newOrder = orderToUpdate - 1;

        $(wrapper).attr("data-file-order", newOrder);
        $(wrapper).attr("id", "file-" + newOrder);
        $(wrapper)
          .find(".custom-file-upload")
          .attr("for", "field_" + fieldID + "_file_" + newOrder);
        $(wrapper)
          .find(".custom-file-input")
          .attr("id", "field_" + fieldID + "_file_" + newOrder);

        // Ensure the input field at index '0' has the required attribute assigned by the form.
        $('.file-input[data-field-id="' + fieldID + '"]')
          .find("#field_" + fieldID + "_file_0")
          .prop("required", requiredBool);
      }
    });
  });
});
